var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnecting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8525 11.0554H15.1488V14.685H18.8525V11.0554ZM26.2599 11.0554H22.5562V14.685H26.2599V11.0554ZM31.8155 22.8517C29.5099 22.8517 27.2877 22.4887 25.2043 21.8172C24.5655 21.6176 23.834 21.7628 23.3247 22.2619L19.2506 26.2635C14.0006 23.6502 9.72287 19.4489 7.04695 14.313L11.121 10.3113C11.6303 9.81224 11.7784 9.09539 11.5747 8.46928C10.8895 6.42761 10.5192 4.24076 10.5192 1.98132C10.5192 0.974096 9.69509 0.166504 8.66732 0.166504H2.18584C1.15806 0.166504 0.333984 0.974096 0.333984 1.98132C0.333984 19.0224 14.4266 32.8332 31.8155 32.8332C32.8432 32.8332 33.6673 32.0256 33.6673 31.0184V24.6665C33.6673 23.6593 32.8432 22.8517 31.8155 22.8517ZM29.9636 11.0554V14.685H33.6673V11.0554H29.9636Z",
    fill: "#515151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnecting);
export default __webpack_public_path__ + "static/media/connecting.6be8363252f0f538ac6307b7e417e70e.svg";
export { ForwardRef as ReactComponent };